import { wordpressPostTypeList } from "/src/actions/wordpress.js";
import { sanitise_params, to_wordpress } from "/src/lib/http/index.js";

// import { WP_POST_TYPE_API } from "config/master.js";

const fetchData = async ({ url, fields, order, page, per_page, max_page, filter, ...otherParams }) => {
  const wordpressFilterParams = to_wordpress(filter); // Make compatible with PHP associative array
  const data = await wordpressPostTypeList({
    url,
    fields,
    order,
    // url: WP_POST_TYPE_API,
    page: page || 1,
    per_page: per_page || 12,
    max_page: max_page || 1,
    // fields: [
    //   "id",
    //   "featured_media",
    //   "featured_media_url",
    //   "title",
    //   "link",
    //   "listing_type",
    //   "price",
    //   "property_type",
    //   "tenure",
    //   "floor_area",
    //   "floor_area_type",
    //   "land_area",
    //   "land_area_type",
    //   "bedrooms",
    //   "bathrooms",
    // ],
    filter: {
      meta_query: {
        relation: "AND",
        // 0: {
        //   key: "property_type_group",
        //   value: "HDB",
        //   compare: "=",
        // },
        ...wordpressFilterParams,
        // 1: {
        //   key: "price",
        //   value: { 0: "500000", 1: "800000" },
        //   type: "numeric",
        //   compare: "BETWEEN",
        // }
      }
    },
    ...otherParams,
  });
  return data;
}

export { fetchData };
